/* istanbul ignore file */
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';
import { FieldProps } from '../types';
import { getWithThousandsSeparator } from '../../../utils/strings/amountUtils';

export const CURRENCIES: Dictionary<string> = {
  USD: '$',
  BYN: 'Br.',
  BYR: 'Br.',
  PLN: 'zł.',
  EUR: '€',
};

interface CurrencyFieldProps extends FieldProps {
  currencySource: string;
  emptyValue?: string;
}

const CurrencyField = ({ source, currencySource, emptyValue, ...props }: CurrencyFieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getCurrency } = useFieldHelper({ source: currencySource });
  const value = getValue() as any;
  const currency = getCurrency() as any;

  return (
    <TextField
      {...props}
      source={source}
      value={value ? `${getWithThousandsSeparator(value)}${CURRENCIES[currency] || ''}` : emptyValue}
    />
  );
};

export default CurrencyField;
